import Box from '@mui/material/Box';
import { StoryblokComponent, storyblokEditable } from '@storyblok/react';
import { object } from 'prop-types';
import React from 'react';

import { withBaseComponent } from '../../hoc/withBaseComponent';

/**
 * Storyblok component: Accordion
 * @param {object} props
 * @param {object} props.blok
 * @param {object} props.baseStyles
 */
const StoryblokAccordion = ({ blok, baseStyles }) => {
  const { general = { items: [] }, extra = { id: '' } } = blok;
  const { id } = extra;
  const { items } = general;

  return (
    <Box id={id} {...storyblokEditable(blok)} sx={{ ...baseStyles, width: '100%' }}>
      {items.map((nestedBlok) => (
        <StoryblokComponent blok={nestedBlok} key={nestedBlok._uid} />
      ))}
    </Box>
  );
};

export default withBaseComponent(StoryblokAccordion);
